// @ts-strict-ignore
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Callout } from '@node-space/ui-components'
import { ExternalLink } from 'components/ExternalLink/ExternalLink'
import { ExternalLinks } from 'constants/links'
import { logSentryErrorAndGetEventId } from '@node-space/utils'

export const NoWalletProfilesCallout = () => {
  const { t } = useTranslation()

  useEffect(() => {
    logSentryErrorAndGetEventId(
      `NoWalletProfilesFound`,
      new Error('No wallet profiles found. Please check that wallet profiles have been correctly configured.'),
    )
  }, [])

  return (
    <Box paddingB={16}>
      <Callout variant="error">
        <p className="text-body-regular">
          {t('customers.noWalletProfilesCalloutMessage')}
          {` ${t('errorMessages.please')} `}
          <ExternalLink href={ExternalLinks.CONTACT_SUPPORT}>
            {t('errorMessages.contactSupport')}
          </ExternalLink>
        </p>
      </Callout>
    </Box>
  )
}
